import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

function NavigationMenu({ activeSection }) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const [urlEndpoint, setUrlEndpoint] = useState("");

    const pathname = location.pathname;

    const handleNavigation = (path) => {
        if (pathname + location.hash !== path) {
            navigate(path);
            // Scroll to section after navigation
            setTimeout(() => {
                const sectionId = path.split('#')[1];
                if (sectionId) {
                    const section = document.getElementById(sectionId);
                    if (section) {
                        section.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            }, 0);
        }
    };

    useEffect(() => {
        setUrlEndpoint(window.location.hash);
    }, [location, params]);

    return (
        <Nav className="m-auto align-items-center" navbarScroll>
            <Link
                to="/#home"
                className={`nav-link ${(urlEndpoint === "" && pathname === "/") || urlEndpoint === '#home' ? 'active' : ''}`}
                onClick={() => handleNavigation('/#home')}
            >
                Home
            </Link>
            <Link
                to="/#about"
                className={`nav-link ${urlEndpoint === '#about' ? 'active' : ''}`}
                onClick={() => handleNavigation('/#about')}
            >
                About
            </Link>
            <Link
                to="/#features"
                className={`nav-link ${urlEndpoint === '#features' ? 'active' : ''}`}
                onClick={() => handleNavigation('/#features')}
            >
                Features
            </Link>
            <Link
                to="/#screens"
                className={`nav-link ${urlEndpoint === '#screens' ? 'active' : ''}`}
                onClick={() => handleNavigation('/#screens')}
            >
                Screens
            </Link>
            <Link
                to="/#howitworks"
                className={`nav-link ${urlEndpoint === '#howitworks' ? 'active' : ''}`}
                onClick={() => handleNavigation('/#howitworks')}
            >
                How to Use
            </Link>
            <Link
                to="/#reviews"
                className={`nav-link ${urlEndpoint === '#reviews' ? 'active' : ''}`}
                onClick={() => handleNavigation('/#reviews')}
            >
                Reviews
            </Link>
            <Link
                to="/contact-us"
                className={`nav-link ${pathname === '/contact-us' ? 'active' : ''}`}
            >
                Contact Us
            </Link>
        </Nav>
    );
}

export default NavigationMenu;
